<script>
    export let name;
</script>

<label for={name}
       class="{$$props.class ?? ''} flex items-center font-medium font-roboto h-full text-white"
>
    <slot/>
</label>
